





























































import WorkRequestEdit from "../components/WorkRequestEdit.vue";
import WorkRequestNew from "../components/WorkRequestNew.vue";
import WorkRequestSearchFilter from "../components/WorkRequestSearchFilter.vue";
import WorkRequestDeleteItem from "../components/WorkRequestDeleteItem.vue";
import WorkRequestCannotDeleteItem from "../components/WorkRequestCannotDeleteItem.vue";
import WorkRequestExport from "../components/WorkRequestExport.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import config from "../config";
import moment from "moment";

function toLocalDateString(dateStr: string): string {
  if (!dateStr) return '';
  const d = (dateStr.includes('T') || dateStr.includes('Z'))
    ? new Date(dateStr)
    : new Date(dateStr + 'T12:00:00');
  return d.toLocaleDateString('en-CA');
}

function toPayloadDate(dateStr: string): string {
  if (!dateStr) return '';
  const base = dateStr.split('T')[0];
  return new Date(base + 'T00:00:00').toISOString();
}

@Component({
  components: {
    WorkRequestEdit,
    WorkRequestNew,
    WorkRequestSearchFilter,
    WorkRequestDeleteItem,
    WorkRequestCannotDeleteItem,
    WorkRequestExport,
  },
})
export default class ClientWorkRequestList extends Vue {
  fields: any[] = [
    { key: 'WorkNo', label: 'Workorder #', sortable: true, thStyle: { width: '7rem' }, tdClass: 'text-nowrap' },
    { key: 'ControlNo', sortable: true, thStyle: { width: '6rem' }, tdClass: 'text-nowrap' },
    { key: 'Manufacturer', sortable: true, thStyle: { width: '11%' } },
    { key: 'Model', sortable: true, thStyle: { width: '8%' } },
    { key: 'Nomenclature', sortable: true, thStyle: { width: '14%' } },
    { key: 'SerialNo', sortable: true, thStyle: { width: '11%' } },
    { key: 'Technician.fullName', label: 'Technician', sortable: true, thStyle: { width: '10%' } },
    { key: 'Request', sortable: true, thStyle: { width: '7%' } },
    { key: 'Schedule', sortable: true, thStyle: { width: '9%' }, tdClass: 'text-nowrap' },
    { key: 'Status', sortable: true, thStyle: { width: '7%' }, tdClass: 'text-nowrap' },
    { key: 'Actions', sortable: false, thStyle: { width: '9rem' }, tdClass: 'text-nowrap' },
  ];

  list: Array<{
    WorkNo: string;
    Manufacturer: string;
    Nomenclature: string;
    Model: string;
    SerialNo: string;
    ControlNo: string;
    HasAllPassed: boolean;
    HasPowerUpTest: boolean;
    HasPressure: boolean;
    HasUnitMount: boolean;
    HasTightness: boolean;
    HasInternalHose: boolean;
    HasPowerCord: boolean;
    HasGroundResistance: boolean;
    HasLeakageCurrent: boolean;
    Verified: boolean;
    GroundResistance: string;
    PressureDisplay: string;
    Symptoms: string;
    Technician: string;
    Type: string;
    HasGroundResistanceNotes: string;
    CleanUnitNotes: string;
    UnitRepairNote: string;
    UnitRepairNotes: any[];
    LeakageCurrentNotes: string;
    ElectricalSafetyNote: string;
    HasCleanUnit: string;
    LeakageCurrentOff: string;
    LeakageCurrentOn: string;
    manualControl: boolean;
    manualQrserialNo: boolean;
    manualManufacturer: boolean;
    manualNomenclature: boolean;
    manualModel: boolean;
    clientId: string;
    template: string;
    hasAttentionLamp: boolean,
    hasPusherBlockMsg: boolean,
    hasCorrectSyringe: boolean,
    hasOcclusion: boolean,
    has5mlAlarm: boolean,
    hasEmptySyringe: boolean,
    hasFlowRate: boolean,
    hasGroundingPadCircuit: boolean,
    hasTestOutputs: boolean,
    testOutputs: any,
    hasPittingPaddles: boolean,
    hasUnitNotDischarge: boolean,
    hasPrinter: boolean,
    hasCheckOutputs: boolean,
    checkOutputSetting5: string,
    checkOutputSetting50: string,
    checkOutputSetting100: string,
    checkOutputSetting200: string,
    checkOutputSettingMax: string,
    parts: any,
  }> = [];
  rows = this.list.length;

  filters: any = {
    count: 0,
    page: 1,
    limit: 10,
    skip: 0,
    search_keyword: undefined,
    where: {
      status: undefined,
      controlNo: undefined,
      qrserialNo: undefined,
      nomenclature: undefined,
      model: undefined,
      manufacturer: undefined,
    },
    order: undefined,
  }

  created() {
    this.fetchWorkRequests();
    this.fetchSerialNumbers();
    this.fetchControlNumbers();
    this.fetchInventoryList();
    this.getClients();
    this.getTechnicians();
    setTimeout(() => {
      const url_string = window.location.href
      const url = new URL(url_string);
      const create = url.searchParams.get("create");
      if (create) this.$bvModal.show('ModalWorkRequestNew');
    }, 500);
  }

  manufacturers: any = [];

  nomenclatures: any = [];

  models: any = [];

  inventoryList = [];

  public async fetchInventoryList(): Promise<void> {
    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "inventory/search",
      data: this.filters,
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    const inventory = response.data.data.inventory;

    inventory.forEach((item: any) => {
      if (!this.manufacturers.includes(item.manufacturer)) this.manufacturers.push(item.manufacturer);
    });

    this.inventoryList = inventory;
  }

  serialNumbers: any[] = [];

  public async fetchSerialNumbers(): Promise<void> {
    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "inventory/search",
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    const inventory = response.data.data.inventory;

    inventory.forEach((item: any) => {
      this.serialNumbers.push(item.qrserialNo);
    });

    // console.log(this.serialNumbers);
  }

  controlNumbers: any[] = [];

  public async fetchControlNumbers(): Promise<void> {
    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "inventory/search",
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    const inventory = response.data.data.inventory;

    inventory.forEach((item: any) => {
      this.controlNumbers.push(item.controlNo);
    });

    // console.log(this.controlNumbers);
  }

  CHUNK_SIZE = 100;
  CHUNK_TIMEOUT_MS = 120000;

  loadingStatus: 'idle' | 'loading' | 'complete' | 'timeout' = 'idle';
  requestGeneration = 0;

  get isLoading(): boolean {
    return this.loadingStatus === 'loading';
  }

  get statusMessage(): string {
    switch (this.loadingStatus) {
      case 'loading':
        return `Loading work orders… (showing first ${this.list.length})`;
      case 'timeout':
        return 'Loading timed out. Not all work orders could be loaded. Please try refreshing the page.';
      case 'complete':
        return 'All work orders loaded';
      default:
        return '';
    }
  }

  public async fetchWorkRequests(): Promise<void> {
    const generation = ++this.requestGeneration;

    this.list = [];
    this.filters.count = 0;
    this.loadingStatus = 'loading';

    let skip = 0;
    let total = Infinity;

    try {
      while (skip < total) {
        const response: any = await axios({
          method: 'post',
          url: config.apiEndpoint + "WorkRequests/search",
          data: { ...this.filters, skip, limit: this.CHUNK_SIZE },
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.$store.state.authentication.token,
            'x-access-token': this.$store.state.authentication.token
          },
          timeout: this.CHUNK_TIMEOUT_MS,
        });

        if (generation !== this.requestGeneration) return;

        total = response.data.data.workRequest_count;
        this.filters.count = total;

        this.list = this.list.concat(this.mapWorkRequests(response.data.data.workRequests));

        skip += this.CHUNK_SIZE;
      }

      if (generation === this.requestGeneration) this.loadingStatus = 'complete';
    } catch (e) {
      if (generation === this.requestGeneration) this.loadingStatus = 'timeout';
    }
  }

  private mapWorkRequests(WorkRequests: any[]): any[] {
    const _workRequests: any = [];

    WorkRequests.forEach((item: any) => {
      const pad = (n, width, z) => {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
      };
      _workRequests.push({
        workRequestId: item.workRequestId,
        ID: pad(item.numberId, 8, '0'),
        WorkNo: pad(item.numberId, 8, '0'),
        ControlNo: item.controlNo,
        Manufacturer: item.manufacturer,
        Nomenclature: item.nomenclature,
        Model: item.model,
        SerialNo: item.qrserialNo,
        HasAllPassed: item.hasAllPassed,
        HasPowerUpTest: item.hasPowerUpTest,
        HasPressure: item.hasPressure,
        HasUnitMount: item.hasUnitMount,
        HasTightness: item.hasTightness,
        HasInternalHose: item.hasInternalHose,
        HasPowerCord: item.hasPowerCord,
        HasGroundResistance: item.hasGroundResistance,
        HasLeakageCurrent: item.hasLeakageCurrent,
        Verified: item.verified,
        GroundResistance: item.groundResistance,
        PressureDisplay: item.pressureDisplay,
        Symptoms: item.symptoms,
        Technician: item.technician || {},
        ScheduledForDate: toLocalDateString(item.scheduledForDate),
        ScheduledForTime: item.scheduledForTime,
        Status: item.status,
        Request: item.type,
        Schedule: item.scheduledForDate
          ? toLocalDateString(item.scheduledForDate) + (item.scheduledForTime ? ' ' + item.scheduledForTime : '')
          : (item.schedule ? moment(item.schedule).format("MM-DD-YYYY HH:mm:ss") : ''),
        HasGroundResistanceNotes: item.groundResistanceNotes,
        CleanUnitNotes: item.cleanUnitNotes,
        UnitRepairNote: item.unitRepairNote,
        UnitRepairNotes: item.unitRepairNotes || [],
        LeakageCurrentNotes: item.leakageCurrentNotes,
        ElectricalSafetyNote: item.electricalSafetyNote,
        HasCleanUnit: item.hasCleanUnit,
        LeakageCurrentOff: item.leakageCurrentOff,
        LeakageCurrentOn: item.leakageCurrentOn,
        manualControl: item.manualControl,
        manualQrserialNo: item.manualQrserialNo,
        manualManufacturer: item.manualManufacturer,
        manualNomenclature: item.manualNomenclature,
        manualModel: item.manualModel,
        clientId: item.clientId,
        template: item.template,
        hasAttentionLamp: item.hasAttentionLamp,
        hasPusherBlockMsg: item.hasPusherBlockMsg,
        hasCorrectSyringe: item.hasCorrectSyringe,
        hasOcclusion: item.hasOcclusion,
        has5mlAlarm: item.has5mlAlarm,
        hasEmptySyringe: item.hasEmptySyringe,
        hasFlowRate: item.hasFlowRate,
        hasGroundingPadCircuit: item.hasGroundingPadCircuit,
        hasTestOutputs: item.hasTestOutputs,
        testOutputs: item.testOutputs,
        hasPittingPaddles: item.hasPittingPaddles,
        hasUnitNotDischarge: item.hasUnitNotDischarge,
        hasPrinter: item.hasPrinter,
        hasCheckOutputs: item.hasCheckOutputs,
        checkOutputSetting5: item.checkOutputSetting5,
        checkOutputSetting50: item.checkOutputSetting50,
        checkOutputSetting100: item.checkOutputSetting100,
        checkOutputSetting200: item.checkOutputSetting200,
        checkOutputSettingMax: item.checkOutputSettingMax,
        parts: item.parts || [],
      });
    });

    return _workRequests;
  }

  clients: any = null;

  async getClients() {
    const response: any = await axios({
      method: 'post',
      url: config.apiEndpoint + "clients/search",
      data: {},
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    if (response.data.success) {
      this.clients = response.data.data.clients;
    }
  }

  technicians = [];

  async getTechnicians() {
    const response: any = await axios({
      method: 'get',
      url: config.apiEndpoint + "users/fetchTechnicians",
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.$store.state.authentication.token,
        'x-access-token': this.$store.state.authentication.token
      },
    });

    if (response.data.success) {
      this.technicians = response.data.data.technicians;
    }
  }
}
